/* tslint:disable */
import {
  Library,
  Screen,
  Tag
} from '../index';

declare var Object: any;
export interface ImageInterface {
  "id": string;
  "FilenameOnServer": string;
  "OriginalFilename": string;
  "Description"?: string;
  "Width": number;
  "Height": number;
  "FileSize": number;
  "hash"?: string;
  "Metadata"?: any;
  "Categories"?: string;
  "Container"?: string;
  "Format"?: string;
  "url"?: string;
  "urlThumb1"?: string;
  "urlThumb2"?: string;
  "urlThumb3"?: string;
  "urlThumb4"?: string;
  "FileExtension"?: string;
  "profileId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId"?: string;
  library?: Library;
  screens?: Screen[];
  tags?: Tag[];
}

export class Image implements ImageInterface {
  "id": string;
  "FilenameOnServer": string;
  "OriginalFilename": string;
  "Description": string;
  "Width": number;
  "Height": number;
  "FileSize": number;
  "hash": string;
  "Metadata": any;
  "Categories": string;
  "Container": string;
  "Format": string;
  "url": string;
  "urlThumb1": string;
  "urlThumb2": string;
  "urlThumb3": string;
  "urlThumb4": string;
  "FileExtension": string;
  "profileId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId": string;
  library: Library;
  screens: Screen[];
  tags: Tag[];
  constructor(data?: ImageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Image`.
   */
  public static getModelName() {
    return "Image";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Image for dynamic purposes.
  **/
  public static factory(data: ImageInterface): Image{
    return new Image(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Image',
      plural: 'Images',
      path: 'Images',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "FilenameOnServer": {
          name: 'FilenameOnServer',
          type: 'string'
        },
        "OriginalFilename": {
          name: 'OriginalFilename',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Width": {
          name: 'Width',
          type: 'number'
        },
        "Height": {
          name: 'Height',
          type: 'number'
        },
        "FileSize": {
          name: 'FileSize',
          type: 'number'
        },
        "hash": {
          name: 'hash',
          type: 'string'
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "Container": {
          name: 'Container',
          type: 'string'
        },
        "Format": {
          name: 'Format',
          type: 'string'
        },
        "url": {
          name: 'url',
          type: 'string'
        },
        "urlThumb1": {
          name: 'urlThumb1',
          type: 'string'
        },
        "urlThumb2": {
          name: 'urlThumb2',
          type: 'string'
        },
        "urlThumb3": {
          name: 'urlThumb3',
          type: 'string'
        },
        "urlThumb4": {
          name: 'urlThumb4',
          type: 'string'
        },
        "FileExtension": {
          name: 'FileExtension',
          type: 'string'
        },
        "profileId": {
          name: 'profileId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
      },
      relations: {
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'ScreenImage',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'imageId'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagImage',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'imageId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Image.ts